/**
 * Вкладки конструктора законопроєкту (прототип v4 lz_struct · lz_stake · lz_int · lz_rel · lz_anl · lz_work): «Структура» ·
 * «Зацікавлені сторони» · «Інтереси» · «Відносини» · «Аналітичні записи» · «Правки» — ключі сегмента вкладки в адресі запису. Метадані
 * задають їх однією вкладкою форми `lawdesigner`; перша з них — вкладка запису за замовчуванням.
 */
export const LAW_TABS: readonly string[] = ['law-structure', 'law-stakeholders', 'law-interests', 'law-relations', 'law-records', 'law-edits'];

/** Чи це вкладка візуальної моделі закону (пункт меню «Візуальна модель закону» активний на них). Чиста функція. */
export function isLawTab(tab: string | undefined): boolean {
  return Boolean(tab) && LAW_TABS.includes(tab as string);
}
